import { render } from "./SidebarSx.vue?vue&type=template&id=36f1d253&scoped=true"
import script from "./SidebarSx.vue?vue&type=script&lang=js"
export * from "./SidebarSx.vue?vue&type=script&lang=js"

import "./SidebarSx.vue?vue&type=style&index=0&id=36f1d253&scoped=true&lang=css"

import exportComponent from "C:\\Users\\diego\\source\\repos\\PoligeoDocumenti\\PoligeoDocumenti\\poligeo-documenti\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f1d253"]])

export default __exports__